<template>
  <component
    :is="tag"
    class="sub-header small-header"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
};
</script>

<style scoped>
.sub-header {
  font-size: 16px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: 0.06em;
  line-height: 1.167;
  text-transform: uppercase;
}
</style>
